import { Pipe, PipeTransform } from '@angular/core';
import { TypeEntreprise } from '../../models/typeEntreprise';

@Pipe({
	name: 'filterTypeEntrepriseByName'
})
export class FilterTypeEntrepriseByNamePipe implements PipeTransform {
	transform(typeEntreprise: TypeEntreprise[], filter: string): TypeEntreprise[] {
		if (
			!typeEntreprise ||
			!filter ||
			typeEntreprise === null ||
			filter === null ||
			filter === ''
		) {
			return typeEntreprise;
		}

		return typeEntreprise.filter((typeEntreprise: TypeEntreprise) => {
			if (typeEntreprise.name) {
				// TODO: add lastName too
				return typeEntreprise.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
